import { ContactApi } from "../../../Shared/Constants/api";
import axiosInstance from "../../../Shared/Utils/axiosInstance";
import { parseResponseError } from "../../../Shared/Utils/errorUtils";

export const getContactsApi = async (params) => {
  try {
    // Crear una instancia de URLSearchParams
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${ContactApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return parseResponseError(error);
    // throw error; // Re-throw error for further handling if needed
  }
};
